import * as React from 'react';
export const IcIp67 = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M9 11h-.5v1H9a.5.5 0 000-1zm3.5 1.5a.5.5 0 101 0 .5.5 0 00-1 0zM12 2a10 10 0 100 20 10 10 0 000-20zM6.5 13.5a.5.5 0 01-1 0v-3a.5.5 0 011 0v3zM9 13h-.5v.5a.5.5 0 01-1 0v-3A.5.5 0 018 10h1a1.5 1.5 0 110 3zm5.5-.5a1.5 1.5 0 11-3 0V12a2 2 0 012-2h.5a.5.5 0 010 1h-.5a.578.578 0 00-.18 0 1.49 1.49 0 011.18 1.5zm3.95-1.78l-1.5 3a.5.5 0 01-.9-.44L17.19 11H16a.5.5 0 010-1h2a.52.52 0 01.43.24.51.51 0 01.02.48z'
      fill='currentColor'
    />
  </svg>
);
